import { type RouteObject, useRoutes } from 'react-router';

type RoutesRendererProps = {
  routes: RouteObject[];
};

const RoutesRenderer = ({ routes }: RoutesRendererProps) => useRoutes(routes);

export default RoutesRenderer;
